import axios from "axios";
import { getUserFromLS } from "../utils/getUserFromLS";
import type { ISocialPromptSeriesReadWithPrompts } from "../Types/account";
import { getTutorialSocialPromptSeries } from "./tutorialFixtureResponses";

export const getSocialPromptSeries = (
    seriesId: string,
    callback: (response: ISocialPromptSeriesReadWithPrompts) => void,
    errorCallback: (error: unknown) => void,
    signal?: AbortSignal
) => {
    const fixture = getTutorialSocialPromptSeries(seriesId);
    if (fixture) {
      if (callback != null) {
        callback(fixture as ISocialPromptSeriesReadWithPrompts);
      }
      return Promise.resolve(fixture);
    }

    const user = getUserFromLS();
    const URL = `${import.meta.env.VITE_API_BASE_URL}/social_prompts/series/${encodeURIComponent(seriesId)}`;
    return axios(URL, {
        method: "GET",
        signal,
        headers: {
            Authorization: `Bearer ${user.access_token}`,
        },
    })
        .then((response) => {
            if (callback != null) {
                callback(response.data as ISocialPromptSeriesReadWithPrompts);
            }
        })
        .catch((error) => {
            if (errorCallback != null) {
                errorCallback(error);
            }
        });
};
